import { useEffect, useState } from "react"
import { api } from "../lib/api"
import { redirectToReviewAuth, storeReviewerToken, takeHmvmTokenFromUrl } from "../lib/hmvmAuth"
import { HmvmFooter, HmvmHeader } from "./HmvmChrome"
import { useLocale } from "../contexts/LocaleContext"
import { useReviewSession } from "../contexts/ReviewSessionContext"

export function AuthGate({ children }: { children: React.ReactNode }) {
  const [ready, setReady] = useState(!import.meta.env.PROD)
  const { t } = useLocale()
  const { setFromMe } = useReviewSession()

  useEffect(() => {
    if (!import.meta.env.PROD) {
      setReady(true)
      return
    }
    let cancelled = false
    ;(async () => {
      const fromUrl = takeHmvmTokenFromUrl()
      if (fromUrl) {
        storeReviewerToken(fromUrl)
        try {
          const created = await api.createSession(fromUrl)
          if (!cancelled) setFromMe(created)
        } catch {
          if (!cancelled) redirectToReviewAuth()
          return
        }
      }
      try {
        const me = await api.me()
        if (!me.sub && !me.role) {
          throw new Error("no session")
        }
        if (!cancelled) {
          setFromMe(me)
          setReady(true)
        }
      } catch {
        if (!cancelled) redirectToReviewAuth()
      }
    })()
    return () => {
      cancelled = true
    }
  }, [setFromMe])

  if (!ready) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#080810' }}>
        <HmvmHeader />
        <div style={{ padding: '48px', fontFamily: 'IBM Plex Mono, monospace', color: '#94a3b8', flex: 1 }}>
          {t("common.signingIn")}
        </div>
        <HmvmFooter />
      </div>
    )
  }
  return <>{children}</>
}
